module.exports = __webpack_public_path__ + "img/gift-3.d803aa16.png";